export const SITE = {
    name: "Solino Pro",
    baseline: "Peinture & revêtement de sol — Vexin français",
    phoneDisplay: "06 50 08 82 82",
    phoneHref: "tel:+33650088282",
    email: "contact@solinopro.fr",
    city: "Chaumont-en-Vexin",
    cp: "60240",
    dept: "Oise",
    siret: "SIRET : 819 907 163 00029",
    decennale: "Assurance décennale : AXA — 14 Rue de Paris, 27140 Gisors",
    instagram: "https://instagram.com/solinopro",
    hours: "Lun. – ven. 8 h – 19 h",
    domain: "solinopro.fr",
};

export const HERO_IMG =
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?q=80&w=2000&auto=format&fit=crop";

export const PROCESS = [
    {
        step: "01",
        title: "Vous décrivez votre projet",
        text: "Formulaire en 2 minutes ou appel direct. Photos bienvenues : elles nous font gagner du temps et vous font gagner sur le chiffrage.",
    },
    {
        step: "02",
        title: "Visite & devis sous 48 h",
        text: "Nous passons voir le chantier quand c'est utile, puis vous recevez un devis détaillé, poste par poste, sans surprise.",
    },
    {
        step: "03",
        title: "Chantier propre, finition nette",
        text: "Protection des sols et du mobilier, travail soigné, rangement chaque soir. Nous ne partons que quand tout est impeccable.",
    },
];

export const SERVICES = [
    {
        slug: "peinture-interieure",
        title: "Peinture intérieure",
        nav: "Peinture intérieure",
        serif: "repensée avec soin.",
        seo: {
            title: "Peinture intérieure à Chaumont-en-Vexin — Rénovation & prix | Solino Pro",
            description: "Peinture intérieure pour votre rénovation intérieure à Chaumont-en-Vexin et dans l'Oise : murs, plafonds, boiseries. Sols et murs finis avec soin, tarifs indicatifs, devis gratuit sous 48 h.",
        },
        short: "Murs, plafonds et boiseries avec des finitions d'atelier — préparation sérieuse, rendu net.",
        hero: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=1200&auto=format&fit=crop",
        price: "à partir de 18 € / m²",
        intro:
            "Une peinture réussie se joue à 80 % dans la préparation. Rebouchage des fissures, ponçage, sous-couche adaptée au support : nous repartons de bases saines pour un rendu régulier, sans traces de reprise ni surépaisseurs. Salon, chambres, plafonds, boiseries — nous travaillons pièce par pièce pour que vous puissiez continuer à vivre chez vous.",
        prestations: [
            "Préparation complète : rebouchage, ponçage, lessivage, sous-couche",
            "Peinture murs et plafonds en finition mate, velours ou satinée",
            "Boiseries : portes, encadrements, plinthes, radiateurs",
            "Finements spéciaux : effet matière, patine, toile de verre",
        ],
        tarifs: [
            ["Reprise d'un mur déjà préparé", "à partir de 18 € / m²"],
            ["Pièce complète — murs + plafond", "à partir de 24 € / m²"],
            ["Boiseries, portes et plinthes", "sur devis"],
        ],
        faq: [
            {
                q: "Quel temps de séchage entre deux couches ?",
                a: "Comptez 4 à 6 heures pour une peinture à l'eau dans une pièce à 20 °C. Nous repassons généralement le lendemain pour la seconde couche.",
            },
            {
                q: "Dois-je vider la pièce avant votre venue ?",
                a: "Non : nous déplaçons et protégeons le mobilier avec des bâches, et nous le remettons en place en fin de chantier.",
            },
            {
                q: "Quelle peinture utilisez-vous ?",
                a: "Des gammes professionnelles de qualité supérieure (résistance au lavage, opulence de couvrance). Les marques précises figurent sur chaque devis.",
            },
        ],
    },
    {
        slug: "peinture-exterieure-facade",
        title: "Peinture extérieure & façade",
        nav: "Peinture façade",
        serif: "sublimée avec soin.",
        seo: {
            title: "Peinture extérieure & façade à Chaumont-en-Vexin — Prix & devis | Solino Pro",
            description: "Peinture extérieure et façade dans l'Oise et le Val-d'Oise : nettoyage, réparation d'enduits, peinture microporeuse. Rénovation durable de vos murs extérieurs — devis gratuit sous 48 h.",
        },
        short: "Façades, volets et menuiseries extérieures protégées des intempéries et valorisées.",
        hero: "https://images.unsplash.com/photo-1574359411659-15573a27fd0c?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.unsplash.com/photo-1589010243150-58666d535521?q=80&w=1200&auto=format&fit=crop",
        price: "à partir de 25 € / m²",
        intro:
            "La façade est la première chose que l'on voit de votre maison — et la première que le climat agresse. Nettoyage, traitement, réparation des enduits puis peinture microporeuse : nous remettons votre maison de sa plus belle cravate tout en la protégeant durablement de la pluie, du gel et des UV.",
        prestations: [
            "Nettoyage haute pression et traitement anti-mousses",
            "Réparation des enduits et rebouchage des fissures",
            "Peinture façade microporeuse respirante",
            "Volets, portes, garde-corps et menuiseries extérieures",
        ],
        tarifs: [
            ["Peinture de façade préparée", "à partir de 25 € / m²"],
            ["Volets (par face)", "à partir de 60 € / volet"],
            ["Réparation d'enduit avant peinture", "sur devis"],
        ],
        faq: [
            {
                q: "À quelle période peindre une façade ?",
                a: "Entre avril et octobre, par temps sec et entre 10 et 25 °C. Nous évitons les façades en plein soleil direct pour éviter que la peinture ne croûte trop vite.",
            },
            {
                q: "Faut-il un autorisation pour repeindre une façade ?",
                a: "Si votre maison est en secteur protégé ou si vous changez la couleur, une déclaration préalable en mairie peut être exigée. Nous vous aidons à y voir clair.",
            },
            {
                q: "Combien de temps tient une peinture de façade ?",
                a: "Une peinture microporeuse de qualité, bien appliquée sur support sain, tient facilement 10 à 15 ans.",
            },
        ],
    },
    {
        slug: "pose-de-parquet",
        title: "Pose de parquet",
        nav: "Pose de parquet",
        serif: "posé avec soin.",
        seo: {
            title: "Pose de parquet à Chaumont-en-Vexin — Rénovation de sols & prix | Solino Pro",
            description: "Pose de parquet stratifié à Chaumont-en-Vexin : rénovation de vos sols dans les règles de l'art, 25 à 40 €/m² pose seule. Tarifs indicatifs, devis gratuit sous 48 h.",
        },
        short: "Parquet stratifié posé et fini dans les règles de l'art — silence et chaleur au sol.",
        hero: "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.unsplash.com/photo-1630699144919-681cf308ae82?q=80&w=1200&auto=format&fit=crop",
        price: "25 à 40 € / m²",
        intro:
            "Le parquet stratifié change radicalement l'ambiance d'une pièce : aspect bois bluffant, résistance au passage, pose flottante rapide et propre — souvent en une seule journée. Nous vous aidons à choisir la gamme adaptée à votre usage et nous préparons toujours le support (ragréage si besoin, sous-couche acoustique) : une pose soignée, des joints réguliers, des plinthes ajustées au millimètre.",
        prestations: [
            "Conseil déco : essences visuelles, largeurs de lames, finitions",
            "Pose flottante sur sous-couche acoustique",
            "Ragréage du support et dépose de l'ancien sol",
            "Plinthes, barres de seuil et finitions assorties",
        ],
        tarifs: [
            ["Parquet stratifié — pose seule", "25 à 40 € / m²"],
            ["Ragréage du support", "à partir de 17 € / m²"],
            ["Dépose de l'ancien sol et plinthes", "sur devis"],
        ],
        faq: [
            {
                q: "Peut-on poser du parquet sur du carrelage ?",
                a: "Oui, en pose flottante avec un primaire d'accrochage et une sous-couche adaptée, si le carrelage est adhérent et plan.",
            },
            {
                q: "Combien de temps pour une pièce de 20 m² ?",
                a: "Une journée en règle générale : ragréage éventuel la veille, pose flottante et plinthes dans la foulée, acclimatation des lames comprise.",
            },
            {
                q: "Stratifié ou vinyle : lequel choisir ?",
                a: "Le stratifié pour les pièces sèches (chambres, séjour, couloirs) ; le vinyle en lames dès qu'il y a de l'eau (cuisine, salle de bain, entrée très sollicitée).",
            },
        ],
    },
    {
        slug: "sol-stratifie-vinyle-pvc",
        title: "Sol stratifié, vinyle & PVC",
        nav: "Stratifié & vinyle",
        serif: "posé avec soin.",
        seo: {
            title: "Sol stratifié, vinyle & PVC à Chaumont-en-Vexin — Prix & devis | Solino Pro",
            description: "Pose de sol stratifié, vinyle en lames et PVC à Chaumont-en-Vexin : rénovation intérieure rapide et résistante, sols et murs. Tarifs indicatifs, devis gratuit sous 48 h.",
        },
        short: "Sols modernes, résistants et rapides à poser — le meilleur rapport rendu / budget.",
        hero: "https://images.unsplash.com/photo-1630699375895-fe5996d163ee?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.unsplash.com/photo-1597665863042-47e00964d899?q=80&w=1200&auto=format&fit=crop",
        price: "à partir de 25 € / m²",
        intro:
            "Stratifié, vinyle en lames ou PVC : ces sols ont énormément progressé. Imperméables pour les pièces d'eau, silencieux avec la bonne sous-couche, ils imitent le bois et la pierre avec un réalisme bluffant — pour un budget maîtrisé et une pose rapide, souvent en une seule journée.",
        prestations: [
            "Stratifié grand trafic pour pièces de vie",
            "Vinyle en lames (SPC) 100 % imperméable, idéal cuisine et salle de bain",
            "Ragréage du support et sous-couche acoustique",
            "Pose de plinthes et finitions soignées",
        ],
        tarifs: [
            ["Pose de stratifié", "à partir de 25 € / m²"],
            ["Pose de vinyle en lames (SPC)", "à partir de 25 € / m²"],
            ["Ragréage du support", "à partir de 17 € / m²"],
        ],
        faq: [
            {
                q: "Vinyle ou stratifié pour une cuisine ?",
                a: "Le vinyle : il est totalement imperméable aux projections d'eau et aux débordements de la cuisine.",
            },
            {
                q: "Le sol vinyle est-il froid ?",
                a: "Plus chaud au toucher que le carrelage, et compatible avec le chauffage au sol basse température.",
            },
            {
                q: "Peut-on poser sur un sol ancien irrégulier ?",
                a: "Il faut d'abord ragréer (rénover le sol avec un enduit de lissage). Nous incluons cette préparation dans le devis.",
            },
        ],
    },
    {
        slug: "pose-de-carrelage",
        title: "Pose de carrelage",
        nav: "Pose de carrelage",
        serif: "posé avec soin.",
        seo: {
            title: "Pose de carrelage à Chaumont-en-Vexin — Sol, mur & prix | Solino Pro",
            description: "Pose de carrelage sol et mur à Chaumont-en-Vexin : rénovation intérieure, dalles plombantes, marches intégrales, faïence. 25 à 60 €/m² pose seule — devis gratuit sous 48 h.",
        },
        short: "Sol et mur, grands formats, salles de bain — calepinage réfléchi, joints propres.",
        hero: "https://images.unsplash.com/photo-1723124280643-f883fd318ce5?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.pexels.com/photos/7546317/pexels-photo-7546317.jpeg?auto=compress&cs=tinysrgb&w=1200",
        price: "25 à 60 € / m²",
        intro:
            "Grand format, métro, damier, imitation bois : le carrelage est un jeu de précision. Nous commençons toujours par un calepinage réfléchi — point de départ, équilibre des coupes, sens de pose — pour que la pièce respire. Étanchéité soignée dans les pièces d'eau, joints impeccables.",
        prestations: [
            "Pose carrelage sol : grès cérame, grands formats, imitation bois",
            "Pose murale : faïence, crédences, dalles murales grand format",
            "Terrasses : dalles plombantes sur plots",
            "Dalles podotactiles — accessibilité PMR",
            "Marches intégrales et marches d'escalier carrelées",
            "Salles de bain : étanchéité (SEL), receveurs à carreler",
        ],
        tarifs: [
            ["Pose carrelage sol standard — pose seule", "25 à 60 € / m²"],
            ["Marche d'escalier carrelée", "70 à 150 € / marche"],
            ["Pose faïence murale", "à partir de 45 € / m²"],
        ],
        faq: [
            {
                q: "Qui fournit le carrelage ?",
                a: "Comme vous préférez : nous pouvons nous approvisionner chez votre fournisseur, ou vous conseiller nos distributors partenaires du secteur.",
            },
            {
                q: "Grand format : quels avantages et limites ?",
                a: "Peu de joints, un rendu spectaculaire — mais un support parfaitement plan est obligatoire. Le ragréage est souvent nécessaire.",
            },
            {
                q: "Délai pour une salle de bain complète ?",
                a: "En général 4 à 6 jours carrelage compris, hors temps de séchage de l'étanchéité.",
            },
        ],
    },
    {
        slug: "habillage-escaliers",
        title: "Habillage d'escaliers",
        nav: "Habillage d'escaliers",
        serif: "relookés avec soin.",
        seo: {
            title: "Habillage d'escaliers à Chaumont-en-Vexin — Rénovation & prix | Solino Pro",
            description: "Habillage d'escaliers et ajustement de portes à Chaumont-en-Vexin : escaliers relookés en bois, stratifié ou vinyle. À partir de 90 €/marche — devis gratuit sous 48 h.",
        },
        short: "Escaliers relookés en bois, stratifié ou vinyle — et portes parfaitement ajustées.",
        hero: "https://images.unsplash.com/photo-1560184984-40825b480203?q=80&w=1800&auto=format&fit=crop",
        gallery: "https://images.unsplash.com/photo-1560184984-40825b480203?q=80&w=1200&auto=format&fit=crop",
        price: "à partir de 90 € / marche",
        intro:
            "Un escalier vieillissant abîme toute une entrée. L'habillage consiste à poser un revêtement neuf — bois, stratifié ou vinyle en lames — directement sur la structure existante : le résultat est un escalier neuf, sans gros œuvre et sans déménager. Nous prenons également en charge l'ajustement de vos portes : réglage, rabotage, changement de bloc-porte.",
        prestations: [
            "Habillage d'escaliers en bois, stratifié ou vinyle",
            "Contremarches, nez de marche antidérapants et finitions",
            "Ajustement et réglage des portes intérieures",
            "Remplacement de blocs-portes et pose de plinthes",
        ],
        tarifs: [
            ["Habillage d'escalier (par marche)", "à partir de 90 € / marche"],
            ["Ajustement d'une porte intérieure", "à partir de 60 € / porte"],
            ["Remplacement de bloc-porte", "sur devis"],
        ],
        faq: [
            {
                q: "Peut-on habiller n'importe quel escalier ?",
                a: "La plupart des escaliers droits ou quart-tournant se prêtent à l'habillage. Nous venons vérifier la structure et la planéité avant de vous confirmer la solution.",
            },
            {
                q: "L'habillage est-il aussi solide qu'un escalier neuf ?",
                a: "Oui : le revêtement est collé et clipsé sur la structure existante, avec des nez de marche adaptés au passage quotidien.",
            },
            {
                q: "Combien de temps pour un escalier complet ?",
                a: "Deux à trois jours pour un escalier droit standard, lissage des marches et finitions comprises.",
            },
        ],
    },
];

export const serviceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);

export const STATS = [
    { value: "10+", label: "années d'expérience" },
    { value: "500+", label: "projets réalisés" },
    { value: "48 h", label: "pour recevoir votre devis" },
];

export const GUARANTEES = [
    "10+ ans d'expérience",
    "500+ projets réalisés",
    "Devis détaillé sous 48 h",
];
